export default function useSort() {
  function sortArray<T>(arr: T[], key?: keyof T, order: 'asc' | 'desc' = 'asc'): T[] {
    // Use browser language for locale-aware sorting
    const locale = navigator.language || 'de';

    return [...arr].sort((a, b) => {
      // Extract values by key or use the item itself as string
      const valA = key ? String(a[key] ?? '') : String(a);
      const valB = key ? String(b[key] ?? '') : String(b);

      // Push empty strings to the end
      if (!valA && valB) return 1;
      if (valA && !valB) return -1;

      // Compare strings based on locale
      const result = valA.localeCompare(valB, locale);

      // Apply sort direction
      return order === 'asc' ? result : -result;
    });
  }

  return { sortArray };
}
